(() => {
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const root = () => window.Shopify?.routes?.root || '/';
  let busy = false;
  const request = async (path, body) => {
    const response = await fetch(root() + path, body ? {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)} : {cache:'no-store'});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your gift. Please try again.');
    return data;
  };
  window.giftOfferState = cart => {
    const settings = window.giftSettings || {};
    const gifts = (cart.items || []).filter(item => String(item.variant_id) === String(settings.variant_id));
    const total = Math.max(0, cart.total_price - gifts.reduce((sum, item) => sum + item.final_line_price, 0));
    const threshold = Math.round(Number(settings.threshold) * 100);
    return {settings, gifts, total, threshold, qualified:total >= threshold, added:gifts.some(item => item.final_line_price === 0)};
  };
  let enforcing = null;
  window.enforceGiftCart = async cart => {
    const state = window.giftOfferState(cart);
    if (!state.settings.enable_gift) return cart;
    const updates = {};
    state.gifts.forEach(item => {
      const quantity = state.qualified ? 1 : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    if (!Object.keys(updates).length) return cart;
    if (!enforcing) enforcing = request('cart/update.js', {updates}).finally(() => { enforcing = null; });
    const updated = await enforcing;
    // Keep the product metadata supplied by the drawer's Liquid section.
    updated.items = updated.items.map(item => ({...cart.items.find(old => old.key === item.key), ...item}));
    return updated;
  };
  const miniCartAddedButtonMarkup = label => `<span class="gwp-add__success"><svg height="9.5" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M0.707031 5.70703L4.70703 9.70703M4.70703 9.70703L5.20703 10.207M4.70703 9.70703L13.707 0.707031" stroke="#111111" stroke-width="2"/></svg><span>${escape(label)}</span></span>`;
  const cartAddPlusIcon = '<span class="gwp-add__plus" aria-hidden="true"><svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="4.056" y1="0" x2="4.056" y2="8" stroke="currentColor"/><line x1="8" y1="4.055" x2="0" y2="4.055" stroke="currentColor"/></svg></span>';
  const cartAddButtonMarkup = label => `<span class="gwp-add__action">${cartAddPlusIcon}<span>${escape(label)}</span></span>`;
  const cartAddedButtonMarkup = label => `<span class="gwp-add__added"><span class="gwp-add__tick" aria-hidden="true"><svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0.530273 2.93125L2.53027 4.93125L6.93027 0.53125" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span>${escape(label)}</span></span>`;
  const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
  window.giftOfferMarkup = (cart, mini = false) => {
    const {settings:s, total, threshold, qualified, added} = window.giftOfferState(cart);
    if (!s.enable_gift || !s.variant_id || !(threshold > 0) || !cart.items?.length || (mini && added)) return '';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:cart.currency || 'USD', maximumFractionDigits:cents % 100 ? 2 : 0}).format(cents / 100);
    return `<section class="gwp-offer ${mini ? 'gwp-mini' : 'gwp-cart'}" aria-label="Complimentary gift">
      ${mini ? `<div class="gwp-progress" role="progressbar" aria-label="Gift eligibility" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.min(100, Math.floor(total / threshold * 100))}"><span style="width:${Math.min(100, total / threshold * 100)}%"></span></div><p class="gwp-status">${qualified ? escape(s.mini_cart_status_qualified || "You're eligible for a complimentary gift!") : `YOU’RE <strong>${escape(money(threshold-total))}</strong> AWAY FROM A COMPLIMENTARY GIFT!`}</p>` : ''}
      <p class="gwp-error" role="alert" hidden></p>
      <div class="gwp-body">${s.image ? `<img src="${escape(s.image)}" alt="${escape(s.gift_description || 'Complimentary gift')}" width="136" height="174">` : ''}<div class="gwp-copy">
      ${mini ? `<p class="gwp-title">${escape(s.gift_description || 'The Unsubscribed Tote')}</p>` : `<p class="gwp-title">${escape(qualified ? (s.cart_title_qualified || 'YOUR COMPLIMENTARY GIFT') : (s.cart_title_unqualified || 'ENJOY AN EXCLUSIVE FREE TOTE'))}</p><p>with any purchase of ${escape(money(threshold))} or more ${s.gift_details_page_link ? `<a href="${escape(s.gift_details_page_link)}">Details</a>` : ''}</p>`}
      ${mini && s.gift_details_page_link ? `<a href="${escape(s.gift_details_page_link)}">Details</a>` : ''}
      ${!mini ? `<button type="button" class="gwp-add textbutton no-hover ${added ? 'gwp-add--added' : qualified ? '' : 'gwp-unqualified'}" data-gwp-add ${added ? 'disabled' : ''}>${added ? cartAddedButtonMarkup(s.cart_added_label || 'TOTE ADDED!') : cartAddButtonMarkup(qualified ? (s.cart_add_label_qualified || 'ADD TOTE') : (s.cart_add_label_unqualified || 'APPLY CODE GIFT'))}</button>` : ''}</div></div>
      ${mini && qualified ? `<button type="button" class="gwp-add" data-gwp-add>${escape(s.mini_cart_add_button_label || 'ADD TOTE TO BAG')}</button>` : ''}
      <span class="gwp-spinner" aria-hidden="true"></span></section>`;
  };
  // Cart page only (#usub_cart_offers). Mini cart renders giftOfferMarkup(cart, true) in the drawer.
  window.renderGiftOffer = async event => {
    const container = document.getElementById('usub_cart_offers');
    if (!container || busy) return;
    try {
      const supplied = event?.detail?.cart;
      const cart = supplied?.items ? supplied : await request('cart.js');
      container.innerHTML = window.giftOfferMarkup(cart, false);
    } catch (error) { console.error('Gift offer:', error); }
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-gwp-add]');
    if (!button || busy) return;
    const offer = button.closest('.gwp-offer');
    const error = offer.querySelector('.gwp-error');
    busy = true;
    let newlyAdded = false;
    try {
      const cart = await request('cart.js');
      const state = window.giftOfferState(cart);
      if (state.added) return;
      if (!state.qualified) throw new Error(`You must purchase ${new Intl.NumberFormat('en', {style:'currency', currency:cart.currency || 'USD', maximumFractionDigits:0}).format(state.threshold/100)} or more to redeem this code.`);
      offer.classList.add('gwp-loading');
      offer.setAttribute('aria-busy', 'true');
      button.disabled = true;
      const codes = (cart.discount_codes || []).filter(code => code.applicable).map(code => code.code);
      codes.push(state.settings.discount_code);
      // Reuse an existing gift variant rather than adding a duplicate.
      if (!state.gifts.length) {
        await request('cart/add.js', {items:[{id:Number(state.settings.variant_id), quantity:1}]});
        newlyAdded = true;
      }
      const updated = await request('cart/update.js', {discount:[...new Set(codes.filter(Boolean))].join(',')});
      if (!window.giftOfferState(updated).added) {
        if (!state.gifts.length) {
          const gift = updated.items.find(item => String(item.variant_id) === String(state.settings.variant_id));
          if (gift) await request('cart/change.js', {id:gift.key, quantity:0});
        }
        throw new Error('The gift code could not be applied. Please try again.');
      }
      offer.classList.remove('gwp-loading');
      offer.removeAttribute('aria-busy');
      const isMini = offer.classList.contains('gwp-mini');
      if (isMini) {
        button.classList.add('gwp-add--success', 'no-hover');
        button.innerHTML = miniCartAddedButtonMarkup(state.settings.mini_cart_added_button_label || 'TOTE ADDED TO BAG!');
        await wait(1000);
      } else {
        button.classList.add('gwp-add--added', 'no-hover');
        button.innerHTML = cartAddedButtonMarkup(state.settings.cart_added_label || 'TOTE ADDED!');
        button.disabled = true;
      }
      document.dispatchEvent(new CustomEvent('theme:cartchanged', {bubbles:true, detail:{cart:updated}}));
      const drawer = document.getElementById('customCartDrawer');
      if (drawer && !drawer.classList.contains('hidden')) await window.openCustomDrawer();
    } catch (failure) {
      if (newlyAdded) {
        try {
          const current = await request('cart.js');
          const unpaid = window.giftOfferState(current).gifts.find(item => item.final_line_price > 0);
          if (unpaid) await request('cart/change.js', {id:unpaid.key, quantity:0});
        } catch (cleanupError) { console.error('Gift cleanup:', cleanupError); }
      }
      error.textContent = failure.message;
      error.hidden = false;
    } finally {
      busy = false;
      button.disabled = false;
      offer.classList.remove('gwp-loading');
      offer.removeAttribute('aria-busy');
      if (error.hidden) window.renderGiftOffer();
    }
  });
  ['cart:updated', 'theme:cartchanged'].forEach(name => document.addEventListener(name, () => window.renderGiftOffer()));
  document.addEventListener('DOMContentLoaded', () => window.renderGiftOffer());
})();
